import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MinimumWordCountValidator } from 'src/app/directives/minimum-word-count-validator.directive';
import { StringHelper } from 'src/app/directives/string-helper';

@Component({
    templateUrl: './perform-action-reject.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PerformedActionRejectModal {

  @Input() requestName!: string;
  /**
   * Output of this modal, when rejected with the reason
   */
  @Output() rejectedWithReason: EventEmitter<string> = new EventEmitter();

  
  MIN_NEEDED_LENGTH = 5;
  MAX_ALLOWED_LENGTH = 500;
  MIN_AMOUNT_OF_WORDS = 2;
  stringHelper = new StringHelper();

  rejectionReasonControl: FormControl;

  constructor(private activeModal: NgbActiveModal) {
    this.rejectionReasonControl = new FormControl('', [
        Validators.required,
        Validators.minLength(this.MIN_NEEDED_LENGTH),
        Validators.maxLength(this.MAX_ALLOWED_LENGTH),
        MinimumWordCountValidator(this.MIN_AMOUNT_OF_WORDS),
    ]);
  }


  close() {
    this.activeModal.close();
  }

  reject() {
    let rejectionReason: string = '';
    if (this.rejectionReasonControl.valid)
      rejectionReason = this.stringHelper.ReplaceRNToBr(this.rejectionReasonControl.value);
    this.rejectedWithReason.emit(rejectionReason);
  }
}
